"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconDigitalDelivery = void 0;
var React = __importStar(require("react"));
var IconDigitalDelivery = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", d: "M10 14.689c.276 0 .5.224.5.5V16h4c.276 0 .5.224.5.5s-.224.5-.5.5h-9c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h4v-.811c0-.276.224-.5.5-.5zM8.475 2v1H1v10h18V3h-7.57V2H19c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1V3c0-.552.448-1 1-1h7.475z", transform: "translate(-16 -186) translate(16 186) translate(2 4)" }),
    React.createElement("path", { fill: "#EC008C", d: "M11.223 5.584l-.74.493c.006-.026.017-.049.017-.077V.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5V6c0 .028.01.051.016.077l-.74-.493c-.23-.153-.54-.09-.692.139-.153.229-.091.54.139.693l1.5 1c.084.056.18.084.277.084.097 0 .193-.028.277-.084l1.5-1c.23-.153.292-.464.139-.693-.153-.229-.464-.292-.693-.139z", transform: "translate(-16 -186) translate(16 186) translate(2 4)" }))); };
exports.IconDigitalDelivery = IconDigitalDelivery;
exports.IconDigitalDelivery.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconDigitalDelivery;
